// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.our-vision-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.our-vision-section .our-vision-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.our-vision-section .our-vision-wrap .our-vision-box {
  --our-vision-box-padding-top: 6rem;
  padding: var(--our-vision-box-padding-top) 0 1rem;
  margin-top: calc(var(--our-vision-box-padding-top) - var(--our-vision-box-padding-top) - var(--our-vision-box-padding-top) / 2);
  position: relative;
}
.our-vision-section .our-vision-wrap .our-vision-box::before {
  content: "";
  width: 200%;
  height: 100%;
  background-color: var(--secondaryMain-1000);
  z-index: -1;
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-4deg);
}
.our-vision-section .our-vision-wrap .our-vision-box .text-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.our-vision-section .our-vision-wrap .our-vision-box .text-box .btn-box {
  margin-top: 2.5rem;
}
@media screen and (max-width: 991.98px) {
  .our-vision-section {
    padding: 2.5rem 0;
  }
  .our-vision-section .our-vision-wrap .our-vision-box {
    --our-vision-box-padding-top: 3.5rem;
  }
  .our-vision-section .our-vision-wrap .our-vision-box .text-box .para-text {
    font-size: 1rem;
  }
  .our-vision-section .our-vision-wrap .our-vision-box .text-box .btn-box {
    margin-top: 2rem;
  }
}
@media screen and (max-width: 767.98px) {
  .our-vision-section {
    padding: 2rem 0;
  }
  .our-vision-section .our-vision-wrap .our-vision-box {
    --our-vision-box-padding-top: 3rem;
    padding-bottom: 1.5rem;
  }
  .our-vision-section .our-vision-wrap .our-vision-box .text-box .para-text {
    font-size: 0.875rem;
  }
  .our-vision-section .our-vision-wrap .our-vision-box .text-box .btn-box {
    margin-top: 1rem;
  }
}
@media screen and (max-width: 639.98px) {
  .our-vision-section {
    padding: 2rem 0;
  }
  .our-vision-section .our-vision-wrap .our-vision-box {
    --our-vision-box-padding-top: 2.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/OurVisionSection/OurVisionStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AACI;EACE,kCAAA;EACA,iDAAA;EACA,+HAAA;EACA,kBAAA;AACN;AACM;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,2CAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8CAAA;AACR;AAGQ;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AADV;AAIQ;EACE,kBAAA;AAFV;AAQE;EA3CF;IA4CI,iBAAA;EALF;EAQI;IACE,oCAAA;EANN;EASQ;IACE,eAAA;EAPV;EAUQ;IACE,gBAAA;EARV;AACF;AAcE;EA/DF;IAgEI,eAAA;EAXF;EAcI;IACE,kCAAA;IACA,sBAAA;EAZN;EAeQ;IACE,mBAAA;EAbV;EAgBQ;IACE,gBAAA;EAdV;AACF;AAoBE;EApFF;IAqFI,eAAA;EAjBF;EAoBI;IACE,oCAAA;EAlBN;AACF","sourcesContent":[".our-vision-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .our-vision-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .our-vision-box {\n      --our-vision-box-padding-top: 6rem;\n      padding: var(--our-vision-box-padding-top) 0 1rem;\n      margin-top: calc(var(--our-vision-box-padding-top) - var(--our-vision-box-padding-top) - var(--our-vision-box-padding-top) / 2);\n      position: relative;\n\n      &::before {\n        content: \"\";\n        width: 200%;\n        height: 100%;\n        background-color: var(--secondaryMain-1000);\n        z-index: -1;\n        pointer-events: none;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%) rotate(-4deg);\n      }\n\n      .text-box {    \n        .para-text {\n          color: var(--black-1000);\n          font-size: 1.5rem;\n          font-weight: 400;\n          line-height: 1.4;\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .our-vision-wrap {  \n      .our-vision-box {  \n        --our-vision-box-padding-top: 3.5rem;\n\n        .text-box {      \n          .para-text {\n            font-size: 1rem;\n          }\n    \n          .btn-box {\n            margin-top: 2rem;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .our-vision-wrap {  \n      .our-vision-box {  \n        --our-vision-box-padding-top: 3rem;\n        padding-bottom: 1.5rem;\n\n        .text-box {      \n          .para-text {\n            font-size: 0.875rem;\n          }\n    \n          .btn-box {\n            margin-top: 1rem;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .our-vision-wrap {  \n      .our-vision-box {  \n        --our-vision-box-padding-top: 2.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
